import React, {useState} from "react";
import {
    TextField,
    Box,
    IconButton,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    Button,
    Stack
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {TimePicker} from '@mui/x-date-pickers/TimePicker';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const TimeRangePicker = ({
                             start,
                             end,
                             onDelete,
                             onChange = () => { },
                             minutesStep = 5,
                             minTime = null,
                             maxTime = null,
                             labelStart = 'Kezdete',
                             labelEnd = 'Vége',
                         }) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleSave = () => {
        setIsEditing(false);
        onChange(startTime?.format("HH:mm"), endTime?.format("HH:mm"));
    };

    const [startTime, setStartTime] = useState(start ? dayjs(start, 'HH:mm') : null);
    const [endTime, setEndTime] = useState(end ? dayjs(end, 'HH:mm') : null);

    const handleStartChange = (newValue) => {
        if (!newValue || !newValue.isValid()) {
            setStartTime(null);
            onChange({start: null, end: endTime ? endTime.format('HH:mm') : null});
            return;
        }

        setStartTime(newValue);

        if (endTime && newValue.isAfter(endTime)) {
            setEndTime(newValue);
            onChange({start: newValue.format('HH:mm'), end: newValue.format('HH:mm')});
        } else {
            onChange({start: newValue.format('HH:mm'), end: endTime ? endTime.format('HH:mm') : null});
        }
    };

    const handleEndChange = (newValue) => {
        if (!newValue || !newValue.isValid()) {
            setEndTime(null);
            onChange({start: startTime ? startTime.format('HH:mm') : null, end: null});
            return;
        }

        setEndTime(newValue);

        if (startTime && newValue.isBefore(startTime)) {
            setStartTime(newValue);
            onChange({start: newValue.format('HH:mm'), end: newValue.format('HH:mm')});
        } else {
            onChange({start: startTime ? startTime.format('HH:mm') : null, end: newValue.format('HH:mm')});
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                padding: 1,
                border: "1px solid",
                borderColor: "primary.light",
                borderRadius: "16px",
                backgroundColor: "primary.50",
            }}
        >
            <Typography variant="caption" color='primary.700' fontSize='100%'>
                {startTime?.format("HH:mm")} - {endTime?.format("HH:mm")}
            </Typography>

            <IconButton onClick={() => setIsEditing(true)} color="primary">
                <EditIcon/>
            </IconButton>

            <IconButton onClick={onDelete} color="primary">
                <DeleteIcon/>
            </IconButton>

            {/* Dialog for editing */}
            <Dialog open={isEditing} onClose={() => setIsEditing(false)}>
                <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box>
                            <Typography variant="body2">{labelStart}</Typography>
                            <TimePicker
                                ampm={false}
                                value={startTime}
                                onChange={handleStartChange}
                                minutesStep={minutesStep}
                                minTime={minTime ? dayjs(minTime, 'HH:mm') : undefined}
                                maxTime={endTime || maxTime ? dayjs(endTime || maxTime, 'HH:mm') : undefined}
                                renderInput={(params) => <TextField variant='standard' {...params} />}
                            />
                        </Box>
                        <Box>
                            <Typography variant="body2">{labelEnd}</Typography>
                            <TimePicker
                                ampm={false}
                                value={endTime}
                                onChange={handleEndChange}
                                minutesStep={minutesStep}
                                minTime={startTime || minTime ? dayjs(startTime || minTime, 'HH:mm') : undefined}
                                maxTime={maxTime ? dayjs(maxTime, 'HH:mm') : undefined}
                                renderInput={(params) => <TextField variant='standard' {...params} />}
                            />
                        </Box>
                    </LocalizationProvider>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsEditing(false)} color="secondary">
                        Mégsem
                    </Button>
                    <Button onClick={handleSave} color="primary">
                        Mentés
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default TimeRangePicker